import React from "react";

export type QuestionsChallengeErrorDisplay = {
  name: string;
  description?: string | React.ReactNode;
};

export const QUESTIONS_CHALLENGE_ERROR_MESSAGES: Record<
  string,
  QuestionsChallengeErrorDisplay
> = {
  operationFailed: {
    name: "La operación falló",
    description:
      "No pudimos completar la validación por un error con el proveedor de Firma Electrónica. Intenta nuevamente.",
  },
  validationFailed: {
    name: "No pudimos validar su identidad",
    description:
      "El servicio de validación no está disponible (proveedor de firma electrónica avanzada). Por favor intenta más tarde.",
  },
  deceasedPerson: {
    name: "Nº de documento inválido",
    description: (
      <>
        Documento registrado como{" "}
        <span style={{ fontWeight: 600 }}>persona fallecida</span>. Si crees que
        es un error, revisa la información con el Registro Civil.
      </>
    ),
  },
  documentNumberMismatch: {
    name: "Nº de documento no coincide con el rut registrado",
  },
  exceededMaxRetries: {
    name: "Excediste el número de intentos",
    description: (
      <>
        Puedes{" "}
        <span style={{ fontWeight: 600 }}>
          completar la verificación con otro método de autenticación
        </span>{" "}
        o volver al inicio e intentar más tarde
      </>
    ),
  },
  unableToGenerateQuestions: {
    name: "No fue posible generar las preguntas",
    description: (
      <>
        El Registro Civil no cuenta con la información suficiente para generar
        el cuestionario. Puedes{" "}
        <span style={{ fontWeight: 600 }}>
          completar la verificación con otro método de autenticación
        </span>{" "}
        o volver al inicio e intentar más tarde.
      </>
    ),
  },
  underagePerson: {
    name: "Nº de documento inválido",
    description: (
      <>
        El documento corresponde a un{" "}
        <span style={{ fontWeight: 600 }}>menor de edad</span>. Si crees que es
        un error, revisa la información con el Registro Civil.
      </>
    ),
  },
  incompleteDataRequired: {
    name: "Se requiere información adicional",
    description:
      "Algunos datos del Registro Nacional de Prestadores Individuales de Salud no fueron encontrados. Por favor, completa los nuevos campos requeridos.",
  },
  unexpectedError: {
    name: "Error inesperado",
    description:
      "No pudimos completar la validación por un error temporal. Intenta nuevamente en unos minutos; si persiste, vuelve más tarde.",
  },
  wrongAnswers: {
    name: "Algunas respuestas estaban incorrectas. Inténtalo nuevamente",
  },
  timeLimitExceeded: {
    name: "Tiempo agotado. Inténtalo nuevamente",
  },
};

const DEFAULT_MESSAGE = QUESTIONS_CHALLENGE_ERROR_MESSAGES.unexpectedError;

export function getQuestionsChallengeErrorDisplay(
  name: string | undefined,
): QuestionsChallengeErrorDisplay {
  if (!name) return DEFAULT_MESSAGE;
  return QUESTIONS_CHALLENGE_ERROR_MESSAGES[name] ?? DEFAULT_MESSAGE;
}
